import React, { Component } from 'react'
import GoogleMap from 'google-map-react'
import Mark from '../../../Maps/mark'

export default class MapDetail extends Component {

  constructor(props) {
    super(props);
  }

  _createMapOptions(maps){
    return {
      panControl: false,
      mapTypeControl: false,
      scrollwheel: false
    }
  }

  shouldComponentUpdate (nextProps, nextState){
    if (this.props.lat !== nextProps.lat){
      return true
    }
    return false
  }

  render () {

    let lat = this.props.lat
    let lng = this.props.lng
    let prop = this.props.prop
    let zoom = 15;
    let center = {
      lat: parseFloat(this.props.lat), lng: parseFloat(this.props.lng),
    }

    const API_KEY = "AIzaSyCm1MEYAHjkfpE-ygYkVPp5-0YIYuD8rxs";

    return (
      <div className="container">
        <GoogleMap
          resetBoundsOnResize={true}
          yesIWantToUseGoogleMapApiInternals={true}
          options={this._createMapOptions}
          center={center}
          zoom={zoom}
          bootstrapURLKeys={{
            key: API_KEY
          }}
          >
          <Mark lat={lat} lng={lng} item={prop} type={'detail'} />
        </GoogleMap>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/Detail/map.js